<div class="users-container">
  <div class="container-fluid">
    <div class="row g-6 mb-6"></div>
    <div class="table-container">
      <div
        class="d-flex justify-content-between align-items-center users-title"
      >
        <h5>Utilizatori</h5>
      </div>
      <div class="table-responsive">
        <table
          datatable
          [dtOptions]="dtOptions"
          class="table table-hover table-nowrap"
        >
          <thead class="thead-light">
            <tr>
              <th scope="col" (click)="sortTable('firstName')">Nume</th>
              <th scope="col" (click)="sortTable('lastName')">Prenume</th>
              <th scope="col" (click)="sortTable('email')">E-mail</th>
              <th scope="col" (click)="sortTable('role')">Rol</th>
              <th scope="col" (click)="sortTable('loginType')">
                Tipul contului
              </th>
              <th></th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</div>
